<template>
    <ModalComponent
        :name="'ver-' + registro.id"
        title="Gestionar Solicitud de Preventa"
        v-on:close="() => emitirCierre(false)"
    >
        <div class="text-center p-3">
            <h3 class="mb-4">
                {{ registro.status === 'rejected'
                    ? '¿Desea aceptar esta solicitud rechazada?'
                    : '¿Desea aceptar o rechazar la solicitud de preventa para este evento?'
                }}
            </h3>

            <div class="alert alert-info d-flex align-items-center text-start" role="alert">
                <i class="fas fa-info-circle fa-lg mr-2"></i>

                <div class="flex-grow-1">
                    <p class="m-0">
                        <strong>Si la aceptas:</strong> avisaremos por correo al solicitante cuando empiece para que pueda comprar.
                    </p>
                    <p v-if="registro.status !== 'rejected'" class="m-0">
                        <strong>Si la rechazas:</strong> este usuario no tendrá acceso a la preventa ni podrá comprar en ese periodo.
                    </p>
                </div>
            </div>


            <div class="card bg-light mb-4">
                <div class="card-body py-2">
                    <p class="mb-1"><strong>Solicitante:</strong> {{ registro.user.name }}</p>
                    <p class="mb-0 small text-muted">{{ registro.user.email }}</p>
                </div>
            </div>

            <div class="d-flex justify-content-center mt-4">
                <button class="btn btn-success mr-2" @click="aceptar">
                    <i class="fas fa-check"></i> Aceptar
                </button>
                <button v-if="registro.status !== 'rejected'" class="btn btn-danger" @click="rechazar">
                    <i class="fas fa-times"></i> Rechazar
                </button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['registro', 'evento_id'],
        methods: {
            emitirCierre(recargar) {
                this.$emit('close', 'ver-' + this.registro.id, recargar);
            },
            aceptar() {
                this.actualizarEstado('selected');
            },
            rechazar() {
                this.actualizarEstado('rejected');
            },
            actualizarEstado(nuevoEstado) {
                const payload = {
                    evento_id: this.evento_id,
                    registro_id: this.registro.id,
                    status: nuevoEstado,
                };

                this.$store.dispatch('BACK_EVENTS_PREVENTA_LISTADO_UPDATE', payload)
                    .then(() => {
                        this.$toast.success('Solicitud actualizada correctamente');
                        this.emitirCierre(true);
                    })
                    .catch(error => {
                        console.error(error);
                        this.$toast.error('Error al actualizar la solicitud');
                    });
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
